import { spreadWord } from '../content';

export function SpreadWord() {
  return (
    <section className="section" id="spread" aria-labelledby="spread-heading">
      <div className="section__inner section__inner--narrow">
        <h2 id="spread-heading" className="section__title">
          {spreadWord.heading}
        </h2>
        <p className="section__lede">{spreadWord.body}</p>
        <a
          className="btn btn--primary"
          href={spreadWord.url}
          target="_blank"
          rel="noreferrer noopener"
        >
          {spreadWord.cta}
        </a>
      </div>
    </section>
  );
}
